var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-change-procedure"},[_c('PlatDataGridSite',{attrs:{"grid-id":"PeStudentChangeProcedure"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }